/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { NgModule } from '@angular/core';
import { BuilderSharedModule } from '@gh/builder-shared';
import { BuilderSetupLetterTemplatesRoutingModule } from './builder-setup-letter-templates-routing.module';
import { LetterTemplateTabContainerComponent } from './components/letter-template-tab-container/letter-template-tab-container.component';
import { LetterTemplateListTabComponent } from './components/letter-template-tab/letter-template-list-tab.component';
import { LtLocationManagementComponent } from './components/letter-template-tab/lt-location-management/lt-location-management.component';
import { LtValidationResultDialogComponent } from './components/letter-template-tab/lt-validation-result-dialog/lt-validation-result-dialog.component';
import { LetterTemplateBusinessService } from './resources/letter-template-business.service';

@NgModule({
  imports: [
    BuilderSharedModule.forChild(),
    BuilderSetupLetterTemplatesRoutingModule,
  ],
  providers: [
    LetterTemplateBusinessService,
  ],
  declarations: [
    LetterTemplateTabContainerComponent,
    LetterTemplateListTabComponent,
    LtLocationManagementComponent,
    LtValidationResultDialogComponent,
  ],
  entryComponents: [
    LtValidationResultDialogComponent,
  ],
})
export class BuilderSetupLetterTemplatesModule {

}
